import React from 'react'
import { Avatar, styled } from '@mui/material'
import { ImageInput, useRecordContext } from 'react-admin'
import get from 'lodash/get'
import { imageUrlConcat } from '../../utils/url-concat'
import { AvatarInputProps, AvatarPreviewProps } from './type'
import { isString } from 'lodash'

const ImageInputStyled = styled(ImageInput)(({ theme }) => ({
  position: 'relative',
  alignItems: 'center',
  ['& .RaFileInput-dropZone']: {
    backgroundColor: theme.palette.common.black,
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    opacity: 0.1,
    bottom: 0,
    zIndex: 1,
    borderRadius: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    transition: theme.transitions.create(['opacity'], {
      duration: theme.transitions.duration.standard,
    }),
    ['&:hover']: {
      opacity: 0.6,
    },
  },
  ['& .MuiFormHelperText-root']: {
    display: 'none',
  },
  ['& .RaFileInput-dropZone svg']: {
    color: theme.palette.common.white,
    width: '80%',
    height: '80%',
  },
  ['& .previews']: {
    position: 'relative',
  },
  ['& .RaFileInputPreview-removeButton ']: {
    display: 'none',
  },
  ['& .RaFileInput-preview']: {},
}))

export const AvatarPreview: React.FC<AvatarPreviewProps> = ({
  height = 150,
  width = 150,
  fallbackSource = null,
  avatarProps = { sx: {} },
}) => {
  const record = useRecordContext()
  const { sx, ...props } = avatarProps
  if (isString(record))
    return <Avatar src={imageUrlConcat(record)} sx={{ ...sx, width, height }} {...props} />
  const fallbackUrl = fallbackSource ? get(record, fallbackSource) : null
  const path = record.src ? record.src : fallbackUrl ? imageUrlConcat(fallbackUrl) : record.src
  return <Avatar src={path} sx={{ ...sx, width, height }} {...props} />
}

export const AvatarInput: React.FC<AvatarInputProps> = ({
  avatarProps,
  width = 150,
  height = 150,
  fallbackSource = null,
  ...props
}) => {
  return (
    <ImageInputStyled
      {...props}
      sx={{
        ['& .RaFileInput-dropZone']: {
          width,
          height,
        },
        ['& .previews']: {
          width,
          height,
        },
      }}
    >
      <AvatarPreview source='src' avatarProps={avatarProps} fallbackSource={fallbackSource} />
    </ImageInputStyled>
  )
}
